import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import Filter from '@app/src/pages/ResourceCollection/Filters/Filter'
import FilterSelect from '@app/src/pages/ResourceCollection/Filters/FilterSelect'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { SortOrder } from '@app/src/types/filter'
import type { User } from '@app/src/types/resourceExplorer'
import React from 'react'
import { useIntl } from 'react-intl'

const ColleagueOwnerFilterSelect: React.FC = () => {
  const { formatMessage } = useIntl()

  const { items: colleagues } = useFetchCollectionWithPost<User>({
    key: FetchKey.Colleague,
    endpoint: endpoints.colleagues,
    payload: {
      filter: [],
      include: ['*'],
      pagination: { pageNumber: 1, itemsPerPage: 9999 },
      sort: { order: SortOrder.ASCENDING, target: 'name' },
    },
  })

  return (
    <Filter operator={Operators.In} name="providerOwners.userId">
      {({ value, onChange }) => (
        <FilterSelect
          size="small"
          multiple
          onChange={value => onChange(value)}
          fieldLabel={formatMessage({ id: 'schemas.provider.ownerUserIds' })}
          value={[value].flat()}
          options={colleagues?.map(user => ({ label: user.name, value: user.id })) ?? []}
        />
      )}
    </Filter>
  )
}

export default ColleagueOwnerFilterSelect
